export const MERCHANT_PROGRAM = {
  DESCRIPTION: 'Now for the exciting part, applying for merchant programs! You\'ll be able to do this when you\'re set up in the system, however to get you started we\'ve provided a couple below we thought might be of interest.',
  TERMS: 'By checking “Apply” your are agreeing to Terms and Conditions for that program - click Terms and Conditions to view for that merchant.',
  BACK: 'Previous step',
  NEXT: 'Next',
  CLOSE_MODAL: 'Close',
};
